import React, { useState } from 'react';
import {
  Fab,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  Backdrop,
  useTheme,
  useMediaQuery
} from '@mui/material';
import {
  Add,
  Person,
  CreditCard,
  Receipt,
  Assessment,
  Close
} from '@mui/icons-material';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const FloatingActionButton = ({ onAction }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const actions = [
    {
      icon: <Person />,
      name: 'Add Member',
      onClick: () => {
        console.log('Add Member');
        onAction?.('add-member');
      },
    },
    {
      icon: <CreditCard />,
      name: 'New Loan',
      onClick: () => {
        navigate('/loan-types');
        onAction?.('new-loan');
      },
    },
    {
      icon: <Receipt />,
      name: 'Record Payment',
      onClick: () => {
        console.log('Record Payment');
        onAction?.('record-payment');
      },
    },
    {
      icon: <Assessment />,
      name: 'Generate Report',
      onClick: () => {
        console.log('Generate Report');
        onAction?.('generate-report');
      },
    },
  ];

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Backdrop open={open} sx={{ zIndex: 1200 }} />
      <SpeedDial
        ariaLabel="Quick Actions"
        sx={{
          position: 'fixed',
          bottom: { xs: 16, sm: 24 },
          right: { xs: 16, sm: 24 },
          zIndex: 1300,
          '& .MuiFab-primary': {
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            '&:hover': {
              background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
              transform: 'scale(1.1)',
            },
            transition: 'all 0.3s ease-in-out',
          },
        }}
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        direction="up"
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            tooltipOpen={!isMobile}
            onClick={() => {
              action.onClick();
              handleClose();
            }}
            sx={{
              '& .MuiFab-primary': {
                backgroundColor: 'background.paper',
                color: 'primary.main',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  color: 'primary.contrastText',
                  transform: 'scale(1.1)',
                },
                transition: 'all 0.3s ease-in-out',
              },
            }}
          />
        ))}
      </SpeedDial>
    </>
  );
};

export default FloatingActionButton;